// SPEC-427 D — 复刻路径纯判定器 (web mirror of worker/src/spec.ts).
//
// Standalone pure module (zero imports, DOM-free — same pattern as layout.ts/doneText.ts), so
// both the web app and the esbuild-based worker tests can consume it. replicate.ts pulls in
// SidePanel (ARTBOARD_PRESETS), whose import chain touches `document` at module init and
// crashes node test bundles — the detectors therefore live HERE and replicate.ts re-exports
// them, keeping every existing import path valid.
//
// Marker lists must stay in sync with worker/src/spec.ts (REPLICATE_MARKERS / NO_REF_MARKERS)
// and the near-empty definition — 镜像同步约定, precedent commit f271ec9 (worker+web 镜像同步).

/** Replication intent markers — mirror of worker/src/spec.ts REPLICATE_MARKERS
 * (SPEC-426 M2 B.1 修复轮: 100% 补齐). */
const REPLICATE_MARKERS = ['复刻', '照着', '仿', '照这个', '做成这样', '还原', '一模一样', '100%'];

export function isReplicateIntent(message: string): boolean {
  return REPLICATE_MARKERS.some(m => message.includes(m));
}

/** SPEC-427 D: 坚持无参考 markers — mirror of worker/src/spec.ts NO_REF_MARKERS. */
const NO_REF_MARKERS = ['无参考', '没有参考', '不用参考', '不需要参考', '直接画', '直接设计', '凭想象'];

export function insistsNoReference(message: string): boolean {
  return NO_REF_MARKERS.some(m => message.includes(m));
}

/** SPEC-427 D: insistsNoReference 路径判定 — 复刻意图 + 无附图 + 用户坚持无参考。
 * 该路径的完成语完整性宣称（完整搭建/可交付等）在 verdict.pass≠true 时被剥离
 *（buildDoneText opts.noReference）；普通创作路径不受影响。 */
export function isNoRefReplicaTurn(message: string, hasImages: boolean): boolean {
  return !hasImages && isReplicateIntent(message) && insistsNoReference(message);
}

/** Near-empty canvas: zero objects, or a single rect (base fill / placeholder) — same rule as worker. */
export function isNearEmptyCanvas(canvas: { objects: { type: string }[] }): boolean {
  const os = canvas.objects;
  if (os.length === 0) return true;
  return os.length === 1 && os[0].type === 'rect';
}
